import React from 'react';

/**
 * 이벤트의 `stopPropagation()`을 호출한다.
 * @param e 대상 이벤트 객체.
 * @returns 대상 이벤트 객체.
 */
export function stopBubbling<E extends Event | React.SyntheticEvent>(event: E): E {
  event.stopPropagation();
  return event;
}
